import { addLocation } from '../../../actions/siteadmin/Location/addLocation';
import { updateLocation } from '../../../actions/siteadmin/Location/updateLocation';

async function submit(values, dispatch) {

    if (values.id) {
        values.isActive = values.isActive == true || values.isActive == 'true' ? 1 : 0;
        await dispatch(
            updateLocation(
                values.locationName,
                JSON.stringify(values.path),
                values.id,
                values.description,
                values.isActive,
            )
        )
    } else {
        await dispatch(
            addLocation(
                values.locationName,
                JSON.stringify(values.path),
                values.description
            )
        )
    }
}

export default submit;